const recentSales = [
  {
    id: "corona-san-ramon",
    address: "4279 San Ramon Dr",
    city: "Corona, CA",
    price: "$1,045,000",
    date: "Mar 2026",
    represented: "Seller",
    image: "https://photos.zillowstatic.com/fp/f376df4783e436d56e252961b4860ec0-p_b.jpg",
  },
  {
    id: "murrieta-sierra-madre",
    address: "27478 Sierra Madre Dr",
    city: "Murrieta, CA",
    price: "$750,000",
    date: "Jan 2026",
    represented: "Buyer",
    image: "https://photos.zillowstatic.com/fp/de04f5b762321bd996c9168e3fcd37d6-p_b.jpg",
  },
  {
    id: "jurupa-50th",
    address: "10402 50th St",
    city: "Jurupa Valley, CA",
    price: "$520,000",
    date: "Mar 2026",
    represented: "Seller",
    image: "https://photos.zillowstatic.com/fp/b8da119a1b25a793b398db6e614300ef-p_b.jpg",
  },
  {
    id: "hemet-shipley",
    address: "3155 Shipley Pl",
    city: "Hemet, CA",
    price: "$485,000",
    date: "Jan 2026",
    represented: "Seller",
    image: "https://photos.zillowstatic.com/fp/b6c5f5455bf13562a8d500210cc6fd76-p_b.jpg",
  },
];

export default function RecentSales() {
  return (
    <section className="py-24 md:py-32 bg-black" data-testid="recent-sales-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4 mb-12">
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="h-px w-12 bg-[#D4AF37]" />
              <span className="text-[#D4AF37] uppercase tracking-[0.2em] text-sm">Proven Results</span>
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-white">
              Recent <span className="text-[#D4AF37]">Sales</span>
            </h2>
          </div>
          <div className="text-right">
            <p className="text-zinc-400 text-sm">Total Career Sales</p>
            <p className="text-[#D4AF37] text-3xl font-black">150+</p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {recentSales.map((sale) => (
            <div
              key={sale.id}
              className="card-dark overflow-hidden group animate-fadeInUp"
              data-testid={`recent-sale-${sale.id}`}
            >
              <div className="aspect-[4/3] overflow-hidden relative">
                <img
                  src={sale.image}
                  alt={sale.address}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-[#D4AF37] text-black text-xs font-bold uppercase px-3 py-1.5 tracking-wider">
                    Sold
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="bg-black/80 text-white text-xs font-semibold px-3 py-1.5">
                    {sale.represented}
                  </span>
                </div>
              </div>
              <div className="p-5 space-y-2">
                <p className="text-[#D4AF37] font-bold text-xl">{sale.price}</p>
                <p className="text-white font-semibold text-sm">{sale.address}</p>
                <p className="text-zinc-400 text-sm">{sale.city}</p>
                <p className="text-zinc-500 text-xs">{sale.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
